import { render, staticRenderFns } from "./loginView.vue?vue&type=template&id=2fce5bfc&scoped=true"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"
import style0 from "./loginView.vue?vue&type=style&index=0&id=2fce5bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce5bfc",
  null
  
)

export default component.exports